<div class="drop-down-auto-complete">
    <div class="dropdown-cell common-drop-down" [ngStyle]="!withInput && {'width':'100%'}">
        <span *ngIf="required" class="required-red">*</span>
        <ng-select class="custom" #select [formControl]="countryControl" [typeahead]="input" placeholder="Enter country"
                   [clearable]="false" [multiple]="false" [items]="items"
                   bindValue="code" (change)="changeCountry($event)" (close)="select.blur(); select.focus()">
            <ng-template ng-label-tmp let-item="item" let-index="index">
                <div *ngIf="item.url !== undefined; else generateData">
                    <div *ngIf="showCode; else showName">
                      <span class="fi fi-{{item.code.toLowerCase()}}" *ngIf="item.code"></span>
                      {{item.code}}
                    </div>
                    <ng-template #showName>
                      <span class="fi fi-{{item.code.toLowerCase()}}" *ngIf="item.code"></span>
                      <span *ngIf="showPhonePrefix"> {{item.phonePrefix}}</span>
                      {{item.countryName}}
                    </ng-template>
                </div>
                <ng-template #generateData>
                    <div fxLayout="row" fxLayoutGap="5px">
                        <div fxLayoutAlign="start start">
                          <span class="fi fi-{{item.code.toLowerCase()}}" *ngIf="item.code"></span>
                        </div>
                        <div fxLayoutAlign="start center">
                          {{showCode ? item.code : item.countryName}}
                        </div>
                    </div>
                </ng-template>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
                <div fxLayout="row" fxLayoutGap="5px">
                    <div fxLayoutAlign="start start">
                      <span class="fi fi-{{item.code.toLowerCase()}}" *ngIf="item.code"></span>
                    </div>
                    <div class="country-name" fxLayoutAlign="start center">
                      {{item.countryName}}
                    </div>
                </div>
            </ng-template>
        </ng-select>
    </div>
</div>
